import { ButtonBase, ButtonBaseProps, Stack, useTheme } from '@mui/material';
import EllipsesTypography from 'components/shared/EllipsesTypography';
import React, { ReactNode } from 'react';
import { TComponentChild } from 'types/props';

interface ISidebarMenuItemProps {
	children?: ReactNode;
	startIcon?: TComponentChild | null;
	endIcon?: TComponentChild | null;
	disableHover?: boolean;
	'data-testid'?: string;
	buttonBaseProps?: ButtonBaseProps;
	active?: boolean;
}

const BUTTON_HEIGHT = 42;

const SidebarMenuItem: React.FC<ISidebarMenuItemProps> = ({
	startIcon = null,
	endIcon = null,
	children = null,
	buttonBaseProps = {},
	disableHover = false,
	'data-testid': dataTestId = null,
	active = false
}) => {
	const {
		palette: {
			primary: { highlight: primaryHighlightColor }
		}
	} = useTheme();

	return (
		<ButtonBase
			{...buttonBaseProps}
			data-testid={dataTestId || 'sidebar-menu-item'}
			sx={{ borderRadius: 1, ...(buttonBaseProps.sx || {}) }}
		>
			<Stack
				direction="row"
				width="100%"
				height={BUTTON_HEIGHT}
				alignItems="center"
				gap={1}
				justifyContent="space-between"
				borderRadius={1}
				px={1}
				overflow="hidden"
				sx={{
					backgroundColor: active ? primaryHighlightColor : undefined,
					transition: 'background-color 100ms ease-in',
					':hover': disableHover
						? {}
						: {
								backgroundColor: primaryHighlightColor
							}
				}}
			>
				<Stack direction="row" alignItems="center" gap={1} overflow="hidden">
					{startIcon}
					<EllipsesTypography variant="body1" component="div">
						{children}
					</EllipsesTypography>
				</Stack>
				{endIcon}
			</Stack>
		</ButtonBase>
	);
};

export default SidebarMenuItem;
export { BUTTON_HEIGHT };
